import type { QuestionResponseType } from "./types/common";

export type ResponseTypeTag = QuestionResponseType["_type"];

export const RESPONSE_TYPE_LABELS: Record<ResponseTypeTag, string> = {
  select: "Select",
  "select-or-other": "Select or Other",
  "multi-select": "Multi-Select",
  "multi-select-or-other": "Multi-Select or Other",
  "multi-select-grouped": "Multi-Select Grouped",
  checkbox: "Checkbox",
  "number-range": "Number Range",
  integer: "Integer",
  vas: "VAS",
  date: "Date",
  text: "Text",
  "text-area": "Text Area",
};

export const RESPONSE_TYPE_ENTRIES = Object.entries(RESPONSE_TYPE_LABELS) as [ResponseTypeTag, string][];
